import { linkShape } from "./primaryNavTypes.js";
const propTypes = {
  item: linkShape,
};

const MenuItem = (props) => {
  const {
    item: { href, title, target, comingSoon, comingSoonLabel, disabled },
    ...otherProps
  } = props;

  const hasTarget = target && target !== "_self" && target !== "";

  if (!disabled) {
    // Active status for Narrative Page
    return (
      <a
        className="primary-nav__menu-item"
        href={href}
        target={hasTarget ? target : undefined}
        {...otherProps}
      >
        {title}{" "}
        {hasTarget && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-arrow-up-right"
          >
            <line x1="7" y1="17" x2="17" y2="7"></line>
            <polyline points="7 7 17 7 17 17"></polyline>
          </svg>
        )}
      </a>
    );
  } else if (comingSoon) {
    // Coming Soon status
    return (
      <div className="menu-item__coming-soon" {...otherProps}>
        <span>{title}</span>
        <span>{comingSoonLabel}</span>
      </div>
    );
  } else {
    // Inactive status
    return null;
  }
};

MenuItem.propTypes = propTypes;
export default MenuItem;
